import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, onMounted, ref } from 'vue'
import TabsOperationLog from '@/components/TabsOperationLog/index.vue'
import TabsConversion from '@/components/TabsConversion'
import TabsClueCosFollowUp from '@/components/TabsClueCosFollowUp'
import TabsContacts from '@/components/TabsContacts/index.vue'
import baseMessage from '@/views/gucangSales/customerCenter/components/baseMessage.vue'
import tabsContract from '@/views/gucangSales/customerCenter/components/tabsContract.vue'
import ViewFooterBtn from '@/views/gucangSales/customerCenter/components/viewFooterBtn.vue'
import tabsCode from '@/views/gucangSales/customerCenter/components/tabsCode.vue'
import tabsBusiness from '@/views/gucangSales/customerCenter/components/tabsBusiness.vue'
import tabsMainBody from '@/views/gucangSales/customerCenter/components/tabsMainBody.vue'
import { potentialDetail } from '@/api/gucangSales/customerCenter'
import { useRoute } from 'vue-router'
import { addToFav, cancelToFav } from '@/api/common'

const __default__ = {
  name: 'FbuContractView'
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const route = useRoute()
const data = ref({})
const operationLogRef = ref()
const contactsRef = ref()
const loading = ref(false)
const activeKey = ref('base')
const isPublicClue = computed(() => route.query.isPublicClue) // 是否是从公海池过来的
// 获取详情
const fetch = () => {
  if (route.query.cosId) {
    loading.value = true
    potentialDetail(route.query.cosId)
      .then((res) => {
        data.value = res.data
      })
      .finally(() => {
        loading.value = false
      })
  }
}
// 标签页切换
const changeTabs = (v: string) => {
  if (v === 'base') {
    fetch()
  } else if (v === 'operationLog') {
    // 更新联系人或者操作日志
    if (activeKey.value === 'contact') {
      contactsRef.value?.refresh()
    } else if (activeKey.value === 'operationLog') {
      operationLogRef.value?.fetch()
    }
  }
}
// 收藏
const addFavorite = () => {
  addToFav({
    appId: 'cos_fbu',
    cosId: data.value.customerInfo.cosId,
    stage: 3
  }).then((res) => {
    if (res.code === 200) {
      data.value.collectionId = data.value.customerInfo.cosId
    }
  })
}
// 收藏
const cancelFavorite = () => {
  cancelToFav({
    appId: 'cos_fbu',
    cosId: data.value.customerInfo.cosId,
    stage: 3
  }).then((res) => {
    if (res.code === 200) {
      data.value.collectionId = null
      data.value.collectionTime = null
    }
  })
}
const permissionBasic = {
  transfer: 'fbu_contract_transfer_btn',
  follow_add: 'fbu_contract_follow_add_btn',
  visitor_add: 'fbu_contract_visitori_add_btn',
  edit: 'fbu_contract_edit_btn',
  buss_add: 'fbu_contract_buss_add_btn',
  concat_add: 'fbu_contract_concat_add_btn'
}
const permissionFollow = {
  edit: 'fbu_contract_follow_edit_btn',
  del: 'fbu_contract_follow_del_btn',
  comment: 'fbu_contract_follow_comment_btn'
}
const permissionBuss = {
  edit: 'fbu_contract_buss_edit_btn',
  del: 'fbu_contract_buss_del_btn'
}
const permissionConcat = {
  edit: 'fbu_contract_concat_edit_btn',
  del: 'fbu_contract_concat_del_btn',
  isPublic: isPublicClue.value === '1'
}
const footerSuccess = (tag: 'base' | 'contact') => {
  if (tag === 'base') {
    fetch()
  } else if (tag === 'contact') {
    contactsRef.value?.refresh()
  }
}
onMounted(() => {
  fetch()
})

return (_ctx: any,_cache: any) => {
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_CosViewContent = _resolveComponent("CosViewContent")!
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!

  return (_openBlock(), _createBlock(_component_dc_layout_main, null, {
    default: _withCtx(() => [
      _createVNode(_component_dc_layout_content, { loading: loading.value }, {
        default: _withCtx(() => [
          _createVNode(_component_CosViewContent, {
            header: "",
            title: data.value?.customerInfo?.customerName,
            sellerName: data.value?.customerInfo?.sellerName,
            "collection-id": data.value?.collectionId,
            customLabel: "主客户代码",
            customValue: data.value?.customerInfo?.customerNumber,
            "add-fav": addFavorite,
            "cancel-fav": cancelFavorite,
            turnedContract: data.value?.customerInfo?.turnedContract,
            turnedPotential: data.value?.customerInfo?.turnedPotential,
            turnedTransaction: data.value?.customerInfo?.turnedTransaction
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_tabs, {
                onChange: changeTabs,
                activeKey: activeKey.value,
                "onUpdate:activeKey": _cache[0] || (_cache[0] = ($event: any) => ((activeKey).value = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_tab_pane, {
                    key: "base",
                    tab: "基本信息"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(baseMessage, {
                        disabled: true,
                        formItemView: "",
                        data: data.value,
                        type: "contract",
                        permissionPage: permissionBasic
                      }, null, 8, ["data"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_tab_pane, {
                    key: "contact",
                    tab: "联系人"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(TabsContacts, {
                        ref_key: "contactsRef",
                        ref: contactsRef,
                        contactRefId: _unref(route).query.cosId,
                        permissionPage: permissionConcat
                      }, null, 8, ["contactRefId"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_tab_pane, {
                    key: "3",
                    tab: "跟进记录"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(TabsClueCosFollowUp), {
                        showFooter: true,
                        followRefId: _unref(route).query.cosId,
                        permissionPage: permissionFollow
                      }, null, 8, ["followRefId"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_tab_pane, {
                    key: "4",
                    tab: "商机"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(tabsBusiness, { permissionPage: permissionBuss })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_tab_pane, {
                    key: "5",
                    tab: "合同信息"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(tabsContract)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_tab_pane, {
                    key: "6",
                    tab: "转化记录"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(TabsConversion), {
                        resourceId: _unref(route).query.cosId
                      }, null, 8, ["resourceId"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_tab_pane, {
                    key: "operationLog",
                    tab: "操作日志"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(TabsOperationLog, {
                        ref_key: "operationLogRef",
                        ref: operationLogRef,
                        tableId: "FbuContractOperationLog",
                        resourceId: _unref(route).query.cosId,
                        appId: "cos_fbu"
                      }, null, 8, ["resourceId"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_tab_pane, {
                    key: "8",
                    tab: "客户代码"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(tabsCode)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_tab_pane, {
                    key: "9",
                    tab: "签约主体"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(tabsMainBody)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["activeKey"])
            ]),
            _: 1
          }, 8, ["title", "sellerName", "collection-id", "customValue", "turnedContract", "turnedPotential", "turnedTransaction"]),
          _createVNode(ViewFooterBtn, {
            permissionPage: permissionBasic,
            onSuccess: footerSuccess,
            loading: loading.value,
            type: "contract",
            data: data.value.customerInfo,
            isPublicClue: isPublicClue.value === '1',
            workCode: data.value?.customerInfo?.seller
          }, null, 8, ["loading", "data", "isPublicClue", "workCode"])
        ]),
        _: 1
      }, 8, ["loading"])
    ]),
    _: 1
  }))
}
}

})